import { Datetime, DatetimeProps } from '@fx-ui/fine-design';
import { dayjsUtils, FALLBACK_REGION, get, isNil, Region } from '@libs/shared';
import React, { useContext } from 'react';
import { regionUtils } from '~/utils';
import { RegionContext } from '~/contexts';

interface RegionDatetimeProps extends Omit<DatetimeProps, 'format'> {
    formatType: keyof Region['dateTimeFormat'];
}

const RegionDatetime: React.FC<RegionDatetimeProps> = (props) => {
    const { formatType, onChange, onAfterChange, ...otherProps } = props;

    const region = useContext(RegionContext);
    const defaultFormat = get(FALLBACK_REGION, ['dateTimeFormat', formatType]);

    return (
        <Datetime
            {...otherProps}
            {...regionUtils.getDatetimeFormat({
                region,
                formatType
            })}
            // 组件库onChange和onAfterChange第二个参数是格式化后的日期时间字符串
            // 若格式是自定义格式，则业务处可能无法正确处理
            // 因此这里统一按默认格式返回
            onChange={(value) => {
                if (isNil(value)) {
                    onChange?.();
                } else {
                    onChange?.(value, dayjsUtils.format(value, defaultFormat));
                }
            }}
            onAfterChange={(value) => {
                if (isNil(value)) {
                    onAfterChange?.();
                } else {
                    onAfterChange?.(value, dayjsUtils.format(value, defaultFormat));
                }
            }}
        />
    );
};

export default RegionDatetime;
